/**
 * Las opciones de FIDELIDAD de Recrear imagen, como se eligen los productos y el modelo
 * (ADR-2026-10-07-fidelidad-se-elige-como-producto-y-modelo): la card del panel abre
 * esto en el panel lateral (escritorio) o en una pantalla propia (teléfono).
 *
 * Cada opción lleva su IMAGEN DE EJEMPLO arriba (`Fidelidad.ejemplo`) y debajo el nombre
 * y la bajada. Sin ejemplo cargado el recuadro queda vacío pero con su alto: así, cuando
 * lleguen las imágenes, el panel no cambia de forma.
 *
 * Tocar una opción la elige; quien lo monta cierra el panel.
 */
import { Check, Image as ImageIcon } from 'lucide-react';
import CachedImg from '../../../../components/CachedImg';
import { FIDELIDADES_EN_PANTALLA, type FidelidadId } from '../../replicarFoto';

export function OpcionesDeFidelidad({
  value,
  onElegir,
  columnas,
}: {
  value: FidelidadId;
  onElegir: (id: FidelidadId) => void;
  /** 2 en el panel lateral; 1 en el teléfono, donde cada opción ocupa el ancho. */
  columnas: number;
}) {
  return (
    <div
      className="grid gap-3"
      style={{ gridTemplateColumns: `repeat(${columnas}, minmax(0, 1fr))` }}
      role="radiogroup"
      aria-label="Fidelidad"
    >
      {FIDELIDADES_EN_PANTALLA.map((f) => {
        const elegida = f.id === value;
        return (
          <button
            key={f.id}
            type="button"
            role="radio"
            aria-checked={elegida}
            onClick={() => onElegir(f.id)}
            className={`relative text-left rounded-2xl p-1 flex flex-col gap-2 transition-colors ${
              elegida
                ? 'bg-black/[0.035] ring-2 ring-brand-primary'
                : 'bg-black/[0.035] hover:bg-black/[0.06]'
            }`}
          >
            {/* El ejemplo. 4:5 en la grilla de escritorio, 16:9 en la lista del teléfono:
                a todo el ancho, un 4:5 dejaba una sola opción por pantalla. */}
            <span
              className={`relative w-full rounded-xl overflow-hidden bg-white grid place-items-center ${
                columnas > 1 ? 'aspect-[4/5]' : 'aspect-[16/9]'
              }`}
            >
              {f.ejemplo ? (
                <CachedImg
                  src={f.ejemplo}
                  alt={`Ejemplo: ${f.nombre}`}
                  className="absolute inset-0 w-full h-full object-cover"
                />
              ) : (
                <ImageIcon className="w-7 h-7 text-black/15" />
              )}
              {elegida && (
                <span className="absolute top-2 right-2 w-6 h-6 rounded-full bg-brand-primary text-white grid place-items-center shadow-sm">
                  <Check className="w-3.5 h-3.5" strokeWidth={3} />
                </span>
              )}
            </span>
            <span className="px-2 pb-2.5 flex flex-col gap-1">
              <span
                className={`text-[14px] font-semibold ${
                  elegida ? 'text-brand-primary' : 'text-brand-black'
                }`}
              >
                {f.nombre}
              </span>
              <span className="text-[12.5px] leading-snug text-black/50">{f.descripcion}</span>
            </span>
          </button>
        );
      })}
    </div>
  );
}
